import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { class: "text-base" }

import WidgetsIcon from "../icons/WidgetsIcon.vue";
import { changeCase } from "../../helpers";
import { ElementE } from '../../enums';

export default /*#__PURE__*/_defineComponent({
  __name: 'LeftMenu',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", {
      class: "flex gap-2 pl-8 border-l-4 border-white font-semibold text-white cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
    }, [
      _createVNode(WidgetsIcon),
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(changeCase)('my widgets', _unref(ElementE).TITLE)), 1)
    ])
  ]))
}
}

})